import EventEmitter from 'events';

import util from '../tools/util';
import Api from '../tools/api';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  fetch,
  isActive,
};

const GAME_NAME = process.env.HARBOUR_GAME_NAME;

let g_eventList = [];

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done: () => void): void {
  fetch();
  done();
}
function isReady() {
  return true;
}
function fetch(done = null) {
  const url = `/cached/${GAME_NAME}/1/event`;
  Api.cdnGet(url, (err, body) => {
    if (err) {
      util.errorLog('EventStore.fetch: err:', err);
    } else {
      g_eventList = body.event_list || [];
      _emit('updated');
    }
    done && done(err);
  });
}

function isActive(event_id: string): boolean {
  let ret = false;
  if (g_eventList) {
    const now = Date.now();
    g_eventList.some(event => {
      if (
        event.event_id === event_id &&
        now > event.start_time &&
        now < event.end_time
      ) {
        ret = true;
      }
      return ret;
    });
  }

  return ret;
}
